import React from "react";
import "../css/CuCheckbox.css";

const CuCheckbox = ({
  label,
  name,
  value,
  onChange,
  checked,
  readOnly = false,
  required = false,
  disabled = false,
  defaultChecked,
}) => {
  return (
    <label className="cu-patient-checkbox-cont">
      <input
        name={name}
        type="checkbox"
        onChange={onChange}
        checked={checked}
        className="focus:ring-green-500 mr-3"
        readOnly={readOnly}
        required={required}
        disabled={disabled}
        defaultChecked={defaultChecked}
        value={value}
      />
      <span className="cu-checkbox-checkbox"></span>
      {label}
    </label>
  );
};

export default CuCheckbox;
